<template>
  <nav class="navbar-default">
    <div class="row mr-3 ml-3 pt-3 mb-3 barra">
      <div class="navbar-minimize col-1">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header col-4">
        <a class="navbar-brand">{{this.$route.name}}</a>
      </div>
      <div class="col-6">
        <div class="nombre">
          <h5>Busqueda</h5>
        </div>
        <div class="nombre">
          <p class="text-muted ente">{{this.ente}}</p>
        </div>
      </div>

      <div class="col-1">
        <drop-down tag="li" title="5 Notificaitons" icon="ti-bell">
          <a slot="title" href="javascript:void(0)" class="dropdown-toggle btn-rotate" data-toggle="dropdown">
            <i class="ti-bell"></i>
            <span class="notification">5</span>
            <p class="hidden-md hidden-lg">
              Notifications
              <b class="caret"></b>
            </p>
          </a>
          <li><a href="javascript:void(0)">Notification 1</a></li>
          <li><a href="javascript:void(0)">Notification 2</a></li>
          <li><a href="javascript:void(0)">Notification 3</a></li>
          <li><a href="javascript:void(0)">Notification 4</a></li>
          <li><a href="javascript:void(0)">Another notification</a></li>
        </drop-down>

      </div>
      <div class="col-1">

        <!-- <div class="ribbon ribbon-top-right" v-if="window.location.hostname == 'localhost' || window.location.hostname == 'apis3.strc.guanajuato.gob.mx'"><span>PRUEBAS</span></div> -->
        <v-btn outlined color="white" small @click.prevent="cerrarSesion" class="ml-2 mr-2">
          Cerrar Sesión
        </v-btn>
        <!-- <div @click="abreSubM" class="btn-rotate float-right h3 m-0">
          <i class="ti-power-off"></i>
        </div> -->
      </div>

    </div>
  </nav>
</template>
<script>
  import {
    eventBus
  } from '../../../main'
  export default {
    data() {
      return {
        activeNotifications: false,
        nombre: '',
        ente: ''
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      cerrarSesion() {
        localStorage.clear();
        eventBus.$emit('cerro');
        this.$router.push('/login');
      },
      abreSubM() {
        var v = this;
        var color = Math.floor((Math.random() * 4) + 1)
        this.$notify({
          component: {
            template: `
              <div @click="cerrarSesion" href="javascript:void(0)"  >
                Cerrar Sesión
              </div>`,
            methods: {
              cerrarSesion() {
                localStorage.clear();
                eventBus.$emit('cerro');
                v.$router.push('/login');
              }
            }
          },
          icon: 'ti-lock',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'info',
          timeout: 150000
        })
      }
    },
    created() {
      this.nombre = this.getKey('nombre');
      this.ente = this.getKey('ente');
    }
  }

</script>
<style>
  .nombre {
    padding-bottom: 0% !important;
    margin-bottom: 0% !important;
    text-align: right !important;
    margin-bottom: 5px !important;
  }

  h5,
  .h5 {
    font-size: 1.2em !important;
    margin-bottom: 5px;
  }

  .ente {
    font-size: 12px !important;
    line-height: 1em !important;
    margin-bottom: 5px !important;
  }

  .barra {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 10px !important;
    margin-top: 0 !important;
  }

  .row.mr-3.ml-3.pt-3.mb-3.barra {
    padding-top: 10px !important;
    margin-bottom: 10px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .pt-3,
  .py-3 {
    padding-top: 10px !important;
  }

  .info {
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/MenuSuperior.vue